import { RootState } from "@/modules/common";

export const selectIsLoading = ({ auth }: RootState) => auth.isLoading;
